import { render } from "./cpt-threejs-dom-option.vue?vue&type=template&id=4581b1aa"
import script from "./cpt-threejs-dom-option.vue?vue&type=script&lang=js"
export * from "./cpt-threejs-dom-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__